import { Obj } from "../utility"
import { setTranslationsList } from "./translator"
import { LocalizationConfigurations } from "./types"

let localesConfigurations: LocalizationConfigurations = {}

/**
 * Set locales configuration options
 * 
 * @param {LocalizationConfigurations} configurations 
 * @returns {void}
 */
export function setLocaleConfigurations(configurations: LocalizationConfigurations): void {
    localesConfigurations = Obj.merge(localesConfigurations, configurations)

    if(localesConfigurations.translations) {
        setTranslationsList(localesConfigurations.translations)
    }
}

/**
 * Set locale config option by given key
 * 
 * @param {string} key
 * @param {any} value 
 * @returns {void}
 */
 export function setLocaleConfig(key: string, value: any): void {
    return Obj.set(localesConfigurations, key, value)
}

/**
 * Get all configurations or get option by key
 * 
 * @param {string} key 
 * @param {any} defaultValue 
 * @returns {any}
 */
export function getLocalConfig(key?: keyof LocalizationConfigurations | string, defaultValue?: any): any {
    if(!arguments || !key) return localesConfigurations

    return Obj.get(localesConfigurations, key, defaultValue)
}

